import { lendersMappingsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LENDERS_MAPPINGS_ACTION_TYPE = createNamedActions('lendersMappings', {
  GET_OPTIMAL_BLUE_INVESTORS: 'GET_OPTIMAL_BLUE_INVESTORS',
  GET_LOAN_SIFTER_INVESTORS: 'GET_LOAN_SIFTER_INVESTORS',
  GET_LENDERS_MAPPINGS: 'GET_LENDERS_MAPPINGS',
  EDIT_LENDERS_MAPPINGS: 'EDIT_LENDERS_MAPPINGS',
});

export const getOptimalBlueInvestorsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await lendersMappingsApi.getOptimalBlueInvestors(params);

  return dispatch({
    type: LENDERS_MAPPINGS_ACTION_TYPE.GET_OPTIMAL_BLUE_INVESTORS,
    payload: data,
  });
});

export const getLoanSifterInvestorsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await lendersMappingsApi.getLoanSifterInvestors(params);

  return dispatch({
    type: LENDERS_MAPPINGS_ACTION_TYPE.GET_LOAN_SIFTER_INVESTORS,
    payload: data,
  });
});

export const getLendersMappingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await lendersMappingsApi.getLendersMappings(params);

  return dispatch({
    type: LENDERS_MAPPINGS_ACTION_TYPE.GET_LENDERS_MAPPINGS,
    payload: data,
  });
});

export const editLendersMappingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await lendersMappingsApi.putLendersMappings(params);

  return dispatch({
    type: LENDERS_MAPPINGS_ACTION_TYPE.EDIT_LENDERS_MAPPINGS,
    payload: data,
  });
});
